import { Avatar, Paper, Popper, useTheme, AvatarGroup, Box } from "@mui/material";
import { AssigneeDetails } from "./AssigneeDetails";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { tokens } from "../../../../../theme";

interface User {
  id?: string | number; 
  first_name: string;
  last_name?: string;
  email: string;
  profile_picture_url?: string;
}

interface Props {
  assignees: User[];
}

export const TableRowAssignees: React.FC<Props> = ({ assignees }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [assigneeDetailsOpen, setAssigneeDetailsOpen] = useState(false);
  const stackRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const stackEl = stackRef.current;
    if (!stackEl) return;

    const displayPaperView = () => {
      setAssigneeDetailsOpen(true);
    };

    const hidePaperView = () => {
      setAssigneeDetailsOpen(false);
    };

    stackEl.addEventListener("mouseenter", displayPaperView);
    stackEl.addEventListener("mouseleave", hidePaperView);

    return () => {
      stackEl.removeEventListener("mouseenter", displayPaperView);
      stackEl.removeEventListener("mouseleave", hidePaperView);
    };
  }, []);

  return (
    <>

      <Box 
        ref={stackRef} 
        sx={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
      >
        <AvatarGroup
          max={3} 
          sx={{
            "& .MuiAvatar-root": {
              width: 26,
              height: 26,
              fontSize: "0.72rem",
              fontWeight: 700,
              border: `2px solid ${theme.palette.background.paper}`,
              backgroundColor: "primary.main",
            },
          }}
        >
          {assignees.map((assignee, index) => (
            <Avatar
              key={assignee.id ?? index}
              alt={`${assignee.first_name} picture`}
              src={assignee.profile_picture_url || undefined}
            >
              {assignee.first_name?.charAt(0).toUpperCase() || "?"}
            </Avatar>
          ))}
        </AvatarGroup>
      </Box>

      <Popper
        open={assigneeDetailsOpen}
        anchorEl={stackRef.current}
        placement="bottom-start"
        style={{
          zIndex: 1300,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            p: 1.5,
            width: "200px",
            borderRadius: "12px",
            backgroundColor: colors.primary[900],
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
          }}
        >
          {assignees.map((assignee, index) => (
            <AssigneeDetails
              key={assignee.id ?? index}
              firstName={assignee.first_name || assignee.email.split("@")[0]}
              lastName={assignee.last_name || ""}
              profileImg={
                assignee.profile_picture_url ||
                assignee.first_name?.charAt(0).toUpperCase() || "?"
              }
            />
          ))}
        </Paper>
      </Popper>
    </>
  );
};

TableRowAssignees.propTypes = {
  assignees: PropTypes.arrayOf(PropTypes.object).isRequired,
};